import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import styles from './detailedDocument.scss'
import documentStyles from './documents.scss'
import stylesMifid from './DSWizardHelper.scss'
import Modal from 'react-modal'
import cs from 'classnames'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import moment from 'moment'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'
import {
    statusExplainerPopup, customModalStyles, getStatusTranslationKey, getStatusDescriptionTranslationKey,
    isAFailStatus, shouldEditThePackage, stakeholderMustAct
} from './documentsHelpers'
import {
    setAppModule, setOpenedSubmenu, setClientSubModule, resendClientRemainder,
    getOneDsPackageById, updatePackagesFromConnective, fetchClient, fetchClientContract,
    fetchClientTarification, fetchClientOneClaim, fetchOneTicketById, setEmailSenderExternalAttachments,
    getDSStakeholders, setEmailSenderModule, setOpenInvitationEditor, recreateDsPackage, setOpenInvitationEditorFromTicket,
    getActualizedPackageForInvitation, handlePackageAfterPrint
} from 'state/actions'
import * as c from 'state/constants'
import ClientContactInfoChangerModalForPackage from './clientContactInfoChangerModalForPackage'
import MifidButton from './mifidButton'
import { getEmailerModuleKeyByWizardModuleKey } from './DSWizardHelper'

import DsListButtonsWrapper from './dsListButtonsWrapper'
import LinkDocumentsModal from './linkToContractAndUploadDocuments/LinkDocumentsModal'
import EmailButton from '../emailSender/emailButton'
import { updateDSStakeholder, upsertDSPackageEmailStatus } from '../../state/actions'
import AreYouSureModal from './AreYouSureModal'
import ReminderEmailStatusDialog from './reminderEmailStatusDialog'
import { canSendInvitation } from 'lib/helpers'

const _ = i18n('dsdocuments')

const HALF_FILLED_PDF_API_URL = "/api/getHalfFilledPdfForPrint"

@connect(
    (state) => ({
        // must fetch the setting
        DigitalSignatureSettings: state.DSDocuments.DigitalSignatureSettings,
        openedPackage: state.DSDocuments.openedPackage,
        clientAccess: state.app.security.actions,
        lang: state.app.lang,
        DSDocumentOriginTypes: nesProp.get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes"),
        createmail: state.app.security.actions.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0,
        EmailTemplateRelations: state.app.security.EmailTemplateRelations,
        forceOpenInvitationFromTicket: state.DSDocuments.forceOpenInvitationFromTicket
    })
)

export default class DetailedPackage extends Component {
    static propTypes = {
        DigitalSignatureSettings: PropTypes.object,
        clientAccess: PropTypes.array,
        openedPackage: PropTypes.string,
        lang: PropTypes.string,
        forceOpenWizard: PropTypes.bool,
        forceOpenInvitationEditor: PropTypes.bool,
        zoomOut: PropTypes.func
    }

    constructor(props) {
        super(props)
        this.state = {
            statusExplainerIsOpen: false,
            editClientEmail: false,
            canCreateMifid: false,
            dsPackage: {},
            isOpenLinkDocumentModal: false,
            stakeholders: null,
            stakeholderToEdit: null,
            isLoaded: true,
            moduleOptions: {},
            ticketData: {},
            isOpenAreYouSure: false,
            autoOpenMifid: false,
            reminderConfirmationModal: false,
            reminderSentSuccessFlag: false,
            invitationBlocked: false
        }
    }

    /**
     * get the package object to display and set security flag
     */
    componentWillMount() {
        const { clientAccess, openedPackage, dispatch } = this.props

        this.fetchDsPackageToDisplay(openedPackage)
            .then((dsPackage) => {
                let moduleKeyToSet = getEmailerModuleKeyByWizardModuleKey(nesProp.get(dsPackage, "uploadedOnModule"))
                dispatch(setEmailSenderModule(moduleKeyToSet, c.EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS))
            })

        // find and set security flag
        clientAccess.map((item, key) => {
            if (item.actionName == 'createmifid') {
                this.setState({ canCreateMifid: item.actionAllowed === "true" ? true : false })
            }
        })
    }

    /**
     * Check if the opened package has changed  and update if it did
     * @param {*} nextProps
     */
    componentWillReceiveProps(nextProps) {
        const { openedPackage } = this.props
        if (nextProps.openedPackage !== openedPackage) {
            this.fetchDsPackageToDisplay(nextProps.openedPackage)
        }
    }

    /**
     * This functionality will call the API used to get the data related to opened package
     * @param {*} openedPackageId
     */
    async fetchDsPackageToDisplay(openedPackageId) {
        const { dispatch } = this.props
        let dsPackage
        try {
            await this.setState({ isLoaded: false })
            dsPackage = await dispatch(getOneDsPackageById(openedPackageId))

            if (dsPackage) {
                let moduleOptions = {}
                let ticketData = {}

                if (!dsPackage.hasFinishStatus) {
                    moduleOptions = await this.collectModuleOptionsValues(dsPackage)
                    if (dsPackage.ticketId) {
                        ticketData = await this.collectTicketData(dsPackage.ticketId)
                    }
                }

                this.setState({ dsPackage, isLoaded: true, moduleOptions, ticketData })
            }
        } catch (error) {
            console.warn(error)
        }

        return dsPackage
    }

    /**
     * This function extract the signing date from status history.
     * @param {*} dsPackage
     */
    getSigningDate(dsPackage) {
        let statusHistory = nesProp.get(dsPackage, "statusHistory")

        if (!statusHistory || statusHistory.length === 0) {
            return false
        }

        let signDate = false
        statusHistory.forEach(oneStatus => {
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                signDate = oneStatus.setOn
            }
        })

        return signDate && moment(signDate).format('DD/MM/YYYY HH:mm:ss')
    }

    /**
    * This function handle the status modal opening
    * @param {string} status
    */
    onItemStatusClick(status) {
        this.setState({ statusExplainerIsOpen: status })
    }

    /**
     * This function provide false if the package has no status of transferred to oracle.
     * @param {*} status
     * @param {*} statusHistory
     */
    documentsAreUploaded(status, statusHistory) {
        let isUploaded = (status === c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE)

        if (!statusHistory) {
            return isUploaded
        }

        statusHistory.forEach((oneStatus) => {
            if (oneStatus.status === c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE) {
                isUploaded = true
            }
        })

        return isUploaded
    }

    /**
     * Refresh package data after the DSWizard close
     */
    onCloseDSWizard() {
        const { openedPackage, zoomOut, forceOpenWizard } = this.props
        if (forceOpenWizard) {
            zoomOut()
        } else {
            this.fetchDsPackageToDisplay(openedPackage)
        }

        this.setState({ autoOpenMifid: false })
    }

    /**
     * Open the model for linking or uploading document
     * @param {*} dsDocument
     */
    openLinkAndUploadWizard(dsDocument) {
        this.setState({ isOpenLinkDocumentModal: dsDocument })
    }

    /**
    * This function helps to use an icon on a safe way
    */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /***
    * Event handler for on resent the email.
    * Update dsPackage data after reminder was sent
    */
    onResendClientRemainder = async (packageId, stakeholderId = null) => {
        const { dispatch } = this.props
        const resendReminderRes = await dispatch(resendClientRemainder(packageId, stakeholderId))

        let reminderSentSuccessFlag = false
        if (resendReminderRes && resendReminderRes.success) {
            reminderSentSuccessFlag = true
        }
        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag })

        if (resendReminderRes) {
            await this.fetchDsPackageToDisplay(packageId)
        }
    }

    /**
    * This method will update package from connective reactivating the main sining link and opens the signing page from connective
    * @param {*} packageId
    */
    async onDirectSignButtonClick(packageId) {
        const { dispatch } = this.props
        const responseFromConnective = await dispatch(updatePackagesFromConnective([packageId]))
        if (responseFromConnective.success) {
            const dsPackage = await dispatch(getOneDsPackageById(packageId))
            let URLForSign = nesProp.get(dsPackage, "F2FSigningUrl")
            this.setState({ dsPackage })
            window.open(URLForSign, '_blank', 'noopener,noreferrer')
        }
    }

    /**
     * This function will handle the signers area legacy prior to version 7 when packages have no stakeholders
     * @param {*} isEditableThePackage
     * @param {*} shouldSendRemainder
     * @returns
     */
    renderSignerArea(isEditableThePackage, shouldSendRemainder) {
        const { dsPackage } = this.state
        let isSignedThePackage = nesProp.get(dsPackage, "hasFinishStatus")
        let canSendNextReminder = +nesProp.get(dsPackage, "remainderRepeats") > 0 ? true : false

        let blocked = false
        const statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed',
            'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError',
            'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'
        ]

        if (dsPackage && dsPackage.statusHistory) {
            dsPackage.statusHistory.forEach((oneStatus) => {
                if (statusBlackList.includes(oneStatus.status)) {
                    blocked = true
                }
            })
        }

        let packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked

        // case fo failed package does not send remainder
        if (packageStatusError) {
            canSendNextReminder = false
        }

        const clientEmailAddress = nesProp.get(dsPackage, "clientEmailAddress")
        return (
            <div>
                <h2 className={`${styles.mainTitle}`}>
                    {_('signersArea')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={styles.columnWrapper}>
                        <div className={styles.signersLabelsColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel, styles.columnTitle)}> </p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerName')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerEmail')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('signerLanguage')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('nextRemainderSendOn')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                        </div>

                        <div className={styles.firstSignerColumn}>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer, styles.columnTitle)}>{_('firstSignerColumnTitle')}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{nesProp.get(dsPackage, "clientName")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <div className={styles.signer}>
                                    <div className={styles.email}>
                                        <a href={`mailto:${clientEmailAddress}`}>{clientEmailAddress}</a>

                                        {!isSignedThePackage &&
                                            <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.setState({ editClientEmail: true })
                                                }} />}

                                    </div>
                                </div>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={cs(styles.signer)}>{nesProp.get(dsPackage, "clientLanguage")}</p>
                            </div>
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{moment(nesProp.get(dsPackage, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss")}</p>

                            </div>
                            {!packageStatusError && canSendNextReminder ?
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>{moment(nesProp.get(dsPackage, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                </div>
                                :
                                <div className={cs(styles.row)}>
                                    <p className={styles.signer}>-</p>
                                </div>
                            }
                            <div className={cs(styles.row)}>
                                <p className={styles.signer}>{((nesProp.get(dsPackage, "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : nesProp.get(dsPackage, "remainderSentCount"))
                                    + " / " + nesProp.get(dsPackage, "remainderRepeats")}</p>
                            </div>
                            {!packageStatusError && !isEditableThePackage && shouldSendRemainder &&
                                <div className={cs(styles.row)}>
                                    <div className={cs(stylesMifid.mifidButtonContainer)}>
                                        <div
                                            key={"resentButton"}
                                            className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                            onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsPackage, "_id"), null))}
                                        >
                                            <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                            {_('resendRemainderEmail')}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     *
     * @param {*} selectedTicketRelatedOraDocuments
     * @returns
     */
    onInitEmailer(selectedTicketRelatedOraDocuments) {
        const { dispatch } = this.props

        if (selectedTicketRelatedOraDocuments && selectedTicketRelatedOraDocuments.length) {
            let files = selectedTicketRelatedOraDocuments.map((oneDoc) => {
                return {
                    name: oneDoc.oracleDocumentType,
                    date: "-",
                    id: oneDoc.oracleDocumentId,
                    typeDocument: oneDoc.oracleDocumentType
                }
            })
            dispatch(setEmailSenderExternalAttachments(files))
        }

        return
    }

    /**
     * Update package ans stakeholder about the invitation.
     * @param {*} responses
     * @param {*} dsPackage
     * @param {*} stakeholder
     * @returns
     */
    async onSentEmailer(responses, dsPackage, stakeholders) {
        const { dispatch } = this.props
        try {
            if (!responses || responses.length === 0) {
                return
            }

            for (let i = 0; i < responses.length; i++) {
                let emailId = nesProp.get(responses, i + ".emailRecord._id")
                let toEmailAddress = nesProp.get(responses, i + ".emailRecord.toEmailAddress")

                if (!emailId) { continue }

                // update all stakeholder as invited
                for (let j = 0; j < stakeholders.length; j++) {
                    if (toEmailAddress && toEmailAddress.length > 0 &&
                        toEmailAddress.some((email) =>
                            (String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase())
                        )
                    ) {
                        await dispatch(upsertDSPackageEmailStatus(
                            dsPackage._id, emailId, { isInvitation: true, stakeholderId: stakeholders[j]._id } /* --> ?? mailOptions*/
                        ))
                        await dispatch(updateDSStakeholder(
                            { stakeholderId: stakeholders[j]._id, isInvited: true }
                        ))
                    }
                }

                dsPackage = await dispatch(getOneDsPackageById(dsPackage._id))
            }

        } catch (e) {
            console.error(e)
            throw e
        }

        return dsPackage
    }

    /**
     * This function will render the stakeholders data
     * @param {*} isEditableThePackage
     * @param {*} shouldSendRemainder
     * @returns stakeholders jsx
     */
    renderStakeholdersArea(isEditableThePackage, shouldSendRemainder) {
        let { dsPackage, ticketData, moduleOptions } = this.state
        const { createmail, dispatch, DSDocumentOriginTypes } = this.props
        const stakeholders = nesProp.get(dsPackage, "dsStakeholders")
        let canSendNextReminder = +nesProp.get(dsPackage, "remainderRepeats") > 0 ? true : false


        let blocked = false
        const statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed',
            'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError',
            'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'
        ]
        if (dsPackage && dsPackage.statusHistory) {
            dsPackage.statusHistory.forEach((oneStatus) => {
                if (statusBlackList.includes(oneStatus.status)) {
                    blocked = true
                }
            })
        }

        let packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked
        // case fo failed package does not send remainder
        if (packageStatusError) {
            canSendNextReminder = false
        }

        const hasSmsOtpSigning = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.find(oneDocument => {
            //check if there is at least one document generated that require signing type sms otp signing
            if (!oneDocument.documentTemplate &&
                (oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE || oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD)) {
                return true
            }

            return oneDocument.documentTemplate && oneDocument.documentTemplate.digitalSignatureType === "SmsOtp"
        }) ? true : false

        // TODO
        // MIRCEA must resolve to get this data from ticket
        let selectedTicketRelatedOraDocuments = ticketData.emailAttachmentTicketDocuments || []

        // prepare module options for emailer of the client
        let emailerModuleOptions1 = {
            ...moduleOptions,
            dsPackage: dsPackage,
            brokerNumber: nesProp.get(dsPackage, "brokerNumber"),
            brokerEmailAddress: nesProp.get(dsPackage, "brokerEmailAddress"),
            stakeholders: [dsPackage.dsStakeholders[0]],
            autoSelectTemplate: true,
            usePlaceholdersForClientVariables: true,
            // overwrite client email addresses, for signer emailaddress-es
            clientEmails: [{
                referenceId: dsPackage.dsStakeholders[0]._id,
                value: dsPackage.dsStakeholders[0].email,
                lang: dsPackage.dsStakeholders[0].language,
                isPermanentSelected: true,
                isCC: false,
                label: dsPackage.dsStakeholders[0].firstName + " " + dsPackage.dsStakeholders[0].lastName
            }]
        }

        let stakeholderOtherPerson = dsPackage.dsStakeholders && dsPackage.dsStakeholders.filter(item => item.signerType === "OTHER_PERSON")
        stakeholderOtherPerson = stakeholderOtherPerson && stakeholderOtherPerson.length > 0 && stakeholderOtherPerson[0]

        let emailerModuleOptions2 = stakeholderOtherPerson && {
            ...moduleOptions,
            dsPackage: dsPackage,
            brokerNumber: nesProp.get(dsPackage, "brokerNumber"),
            brokerEmailAddress: nesProp.get(dsPackage, "brokerEmailAddress"),
            autoSelectTemplate: true,
            usePlaceholdersForClientVariables: true,
            stakeholders: [stakeholderOtherPerson],
            clientEmails: [{
                referenceId: stakeholderOtherPerson._id,
                value: stakeholderOtherPerson.email,
                lang: stakeholderOtherPerson.language,
                isPermanentSelected: true,
                isCC: false,
                label: stakeholderOtherPerson.firstName + " " + stakeholderOtherPerson.lastName
            }]
        }

        let stakeholderBroker = dsPackage.dsStakeholders && dsPackage.dsStakeholders.filter(item => item.signerType === "BROKER")
        stakeholderBroker = stakeholderBroker && stakeholderBroker.length > 0 && stakeholderBroker[0]

        return (
            <div>
                <h2 className={`${styles.mainTitle}`}>
                    {_('signersArea')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={styles.columnWrapperForSigners}>

                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel, styles.columnTitle)}></p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <p className={cs(styles.signer, styles.columnTitle)}>{_('firstSignerColumnTitle')}</p>
                            </div>
                            {stakeholderOtherPerson &&
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={cs(styles.signer, styles.columnTitle)}>{_('secondSignerColumnTitle')}</p>
                                </div>}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('signerName')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <p className={cs(styles.signer)}>{stakeholders[0].lastName + ' ' + stakeholders[0].firstName}</p>
                            </div>
                            {stakeholderOtherPerson &&
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={cs(styles.signer)}>{stakeholderOtherPerson.lastName + ' ' + stakeholderOtherPerson.firstName}</p>
                                </div>}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('signerEmail')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <div className={styles.signer}>
                                    <div className={styles.email}>
                                        <a href={`mailto:${stakeholders[0].email}`}>{stakeholders[0].email}</a>
                                        {!stakeholders[0].finished &&
                                            <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.setState({ editClientEmail: true, stakeholderToEdit: stakeholders[0] })
                                                }}
                                            />}
                                    </div>
                                </div>
                            </div>
                            {stakeholderOtherPerson &&
                                <div className={cs(styles.secondValueColumn)}>
                                    <div className={styles.signer}>
                                        <div className={styles.email}>
                                            <a href={`mailto:${stakeholderOtherPerson.email}`}>{stakeholderOtherPerson.email}</a>
                                            {!stakeholderOtherPerson.finished &&
                                                <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.setState({ editClientEmail: true, stakeholderToEdit: stakeholderOtherPerson })
                                                    }} />}
                                        </div>
                                    </div>
                                </div>}
                        </div>

                        {hasSmsOtpSigning &&
                            <div className={cs(styles.row)}>
                                <div className={cs(styles.labelColumn)}>
                                    <p className={cs(styles.signersLabel)}>{_('signerPhoneNumber')}</p>
                                </div>
                                <div className={cs(styles.firstValueColumn)}>
                                    <div className={styles.signer}>
                                        <div className={styles.email}>
                                            <a href={`mailto:${stakeholders[0].phoneNumber}`}>{stakeholders[0].phoneNumber}</a>
                                            {!stakeholders[0].finished &&
                                                <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholders[0] })
                                                    }}
                                                />}
                                        </div>
                                    </div>
                                </div>
                                {stakeholderOtherPerson &&
                                    <div className={cs(styles.secondValueColumn)}>
                                        <div className={styles.signer}>
                                            <div className={styles.email}>
                                                <a href={`mailto:${stakeholderOtherPerson.phoneNumber}`}>{stakeholderOtherPerson.phoneNumber}</a>
                                                {!stakeholders[0].finished &&
                                                    <img className={styles.icon} src={this.getIcon('create-24px.svg')}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.setState({ editClientPhoneNumber: true, stakeholderToEdit: stakeholderOtherPerson })
                                                        }} />}
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        }

                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('signerLanguage')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <p className={cs(styles.signer)}>{stakeholders[0].language}</p>
                            </div>
                            {stakeholderOtherPerson &&
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={cs(styles.signer)}>{stakeholderOtherPerson.language}</p>
                                </div>
                            }
                        </div>



                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('lastRemainderSentOn')}</p>
                            </div>
                            {isEditableThePackage ?
                                <div className={cs(styles.firstValueColumn)}>
                                    <p className={styles.signer}>{_('reminderSentOnNotReady')}</p>
                                </div>
                                :
                                <div className={cs(styles.firstValueColumn)}>
                                    <p className={styles.signer}>{
                                        /*
                                            Until the stakeholder not invited, don't show the date of first invitation.
                                            The property have value always because the calculation of remainder.
                                        */
                                        nesProp.get(stakeholders[0], "isInvited") ?
                                            moment(nesProp.get(stakeholders[0], "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss") :
                                            "-"
                                    }</p>
                                </div>
                            }

                            {(stakeholderOtherPerson && (isEditableThePackage) ?
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={styles.signer}>{_('reminderSentOnNotReady')}</p>
                                </div>
                                :
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={styles.signer}>
                                        {/*
                                            Until the stakeholder not invited, don't show the date of first invitation.
                                            The property have value always because the calculation of remainder.
                                        */
                                            nesProp.get(stakeholderOtherPerson, "isInvited") ?
                                                moment(nesProp.get(stakeholderOtherPerson, "reminderSentOn")).format("DD/MM/YYYY HH:mm:ss") :
                                                "-"
                                        }
                                    </p>
                                </div>
                            )}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('nextRemainderSendOn')}</p>
                            </div>
                            {!isEditableThePackage && !packageStatusError ?
                                canSendNextReminder && !packageStatusError ?
                                    <div className={cs(styles.firstValueColumn)}>
                                        <p className={styles.signer}>{moment(nesProp.get(stakeholders[0], "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    </div>
                                    :
                                    <div className={cs(styles.firstValueColumn)}>
                                        <p className={styles.signer}>-</p>
                                    </div>
                                :
                                <div className={cs(styles.firstValueColumn)}>
                                    <p className={styles.signer}>{_('nextReminderNotReady')}</p>
                                </div>
                            }
                            {stakeholderOtherPerson && !packageStatusError && (!isEditableThePackage ?
                                canSendNextReminder && !packageStatusError ?
                                    <div className={cs(styles.secondValueColumn)}>
                                        <p className={styles.signer}>{moment(nesProp.get(stakeholderOtherPerson, "nextRemainderOn")).format("DD/MM/YYYY HH:mm:ss")}</p>
                                    </div>
                                    :
                                    <div className={cs(styles.secondValueColumn)}>
                                        <p className={styles.signer}>-</p>
                                    </div>
                                :
                                <div className={cs(styles.secondValueColumn)}>
                                    <p className={styles.signer}>{_('nextReminderNotReady')}</p>
                                </div>
                            )}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('remainderCount')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholders[0], "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : nesProp.get(stakeholders[0], "remainderSentCount"))
                                    + " / " + nesProp.get(dsPackage, "remainderRepeats")}</p>
                            </div>
                            {stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholderOtherPerson, "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : nesProp.get(stakeholderOtherPerson, "remainderSentCount"))
                                    + " / " + nesProp.get(dsPackage, "remainderRepeats")}</p>
                            </div>
                            }
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('manuallRemainderCount')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholders[0], "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : (nesProp.get(stakeholders[0], "remainderSentCountManually") || 0))
                                    + " / " + _("infinite")}</p>
                            </div>
                            {stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                <p className={styles.signer}>{((nesProp.get(stakeholderOtherPerson, "remainderRepeats") + "" === "-1") ?
                                    _("infinite") : (nesProp.get(stakeholderOtherPerson, "remainderSentCountManually") || 0))
                                    + " / " + _("infinite")}</p>
                            </div>}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('signingStatusLabel')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                {stakeholders[0].finished &&
                                    <p className={cs(styles.signer)}>{_('signerHasSignedStatus')}</p> ||
                                    <p className={cs(styles.signer)}>{_('signerHasNotSignedStatus')}</p>
                                }
                            </div>
                            {stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                {stakeholderOtherPerson.finished &&
                                    <p className={cs(styles.signer)}>{_('signerHasSignedStatus')}</p> ||
                                    <p className={cs(styles.signer)}>{_('signerHasNotSignedStatus')}</p>
                                }
                            </div>}
                        </div>


                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}>{_('brokerSignerAffection')}</p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                {!stakeholderBroker &&
                                    <p className={cs(styles.signer)}>{_('brokerSignerDoesNOtNeedToSign')}</p>
                                }
                                {stakeholderBroker && !stakeholderBroker.finished &&
                                    <p className={cs(styles.signer)}>{_('brokerSignerNotFinishedStatus')}</p>
                                }
                                {stakeholderBroker && stakeholderBroker.finished &&
                                    <p className={cs(styles.signer)}>{_('brokerSignerFinishedStatus')}</p>
                                }
                            </div>
                            {stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                <p className={cs(styles.signer)}> </p>
                            </div>}
                        </div>

                        {/* BUTTONS */}
                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}> </p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                {!packageStatusError && stakeholderMustAct(stakeholders[0]) && !isEditableThePackage && shouldSendRemainder && stakeholders[0].isInvited &&
                                    <div className={cs(stylesMifid.mifidButtonContainer, styles.remainderButtonCorrection)}>
                                        <div
                                            key={"resentButton"}
                                            className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                            onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsPackage, "_id"), stakeholders[0]._id))}
                                        >
                                            <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                            {_('resendRemainderEmail')}
                                        </div>
                                    </div>
                                }
                            </div>
                            {stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                {!packageStatusError && stakeholderMustAct(stakeholderOtherPerson) && !isEditableThePackage && shouldSendRemainder && stakeholderOtherPerson.isInvited &&
                                    stakeholderOtherPerson.signerType !== "BROKER" &&
                                    <div className={cs(stylesMifid.mifidButtonContainer, styles.remainderButtonCorrection)}>
                                        <div
                                            key={"resentButton"}
                                            className={cs(stylesMifid.grayButtonFlex, stylesMifid.mifidButton)}
                                            onClick={(e) => (this.onResendClientRemainder(nesProp.get(dsPackage, "_id"), stakeholderOtherPerson._id))}
                                        >
                                            <img className={cs(styles.icon, styles.iconPaddingRight)} src={this.getIcon('icn-inbox-white.svg')} />
                                            {_('resendRemainderEmail')}
                                        </div>
                                    </div>
                                }
                            </div>}
                        </div>

                        {/* BUTTONS 2 */}
                        <div className={cs(styles.row)}>
                            <div className={cs(styles.labelColumn)}>
                                <p className={cs(styles.signersLabel)}> </p>
                            </div>
                            <div className={cs(styles.firstValueColumn)}>
                                {!packageStatusError && !isEditableThePackage && stakeholders[0] && stakeholderMustAct(stakeholders[0]) && !stakeholders[0].isInvited && createmail &&
                                    <EmailButton
                                        onInit={() => {
                                            this.onInitEmailer(selectedTicketRelatedOraDocuments)
                                        }}
                                        onSentLate={async (responses) => {
                                            dsPackage = await this.onSentEmailer(responses, dsPackage, [stakeholders[0]])
                                            this.setState({ dsPackage })
                                        }}
                                        moduleKeyToSet={getEmailerModuleKeyByWizardModuleKey(nesProp.get(dsPackage, "uploadedOnModule"))}
                                        moduleOptions={emailerModuleOptions1}
                                        getDSStakeholders={async (stakeholderIdArray) => (await dispatch(getDSStakeholders(stakeholderIdArray)))}
                                        customButtonLabel={_('customizeInvitationEmail')}
                                        customClassName={documentStyles.greenButton + " enabled"}
                                        key={"customizeInvitationRenderEmailSenderButtonFromDetailedPackageKey"}
                                        isWhiteIcon={true}
                                        modalId={c.EMAILER_MODAL_ID_PACKAGE_DETAILS}
                                        hideCC={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true}
                                        multiLanguage={true}
                                        serialSending={true}
                                        isCreatable={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false}
                                        forceIsMulti={false}
                                        isInvitation={true}
                                        packageStatusCheck={async () => await this.onSendInvitationClick(dsPackage.id)}
                                    />
                                }
                            </div>
                            {!packageStatusError && stakeholderOtherPerson && <div className={cs(styles.secondValueColumn)}>
                                {!isEditableThePackage && stakeholderOtherPerson && stakeholderMustAct(stakeholderOtherPerson) &&
                                    !stakeholderOtherPerson.isInvited && createmail && stakeholderOtherPerson.signerType !== "BROKER" &&
                                    <EmailButton
                                        onInit={() => {
                                            this.onInitEmailer(selectedTicketRelatedOraDocuments)
                                        }}
                                        onSentLate={async (responses) => {
                                            dsPackage = await this.onSentEmailer(responses, dsPackage, [stakeholderOtherPerson])
                                            this.setState({ dsPackage })
                                        }}
                                        moduleKeyToSet={getEmailerModuleKeyByWizardModuleKey(nesProp.get(dsPackage, "uploadedOnModule"))}
                                        moduleOptions={emailerModuleOptions2}
                                        getDSStakeholders={async (stakeholderIdArray) => (await dispatch(getDSStakeholders(stakeholderIdArray)))}
                                        customButtonLabel={_('customizeInvitationEmail')}
                                        customClassName={documentStyles.greenButton + " enabled"}
                                        key={"customizeInvitationRenderEmailSenderButtonFromDetailedPackageKey2"}
                                        isWhiteIcon={true}
                                        modalId={c.EMAILER_MODAL_ID_PACKAGE_DETAILS_2}
                                        hideCC={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true}
                                        multiLanguage={true}
                                        serialSending={true}
                                        isCreatable={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false}
                                        forceIsMulti={false}
                                        isInvitation={true}
                                        packageStatusCheck={async () => await this.onSendInvitationClick(dsPackage.id)}
                                    />
                                }
                            </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    /**
     * This function provide false if can't be sent a remainder.
     * @param {*} dsPackage
     */
    shouldSendRemainder(dsPackage) {
        const { DSDocumentOriginTypes } = this.props
        let should = false
        // can be enabled the remainder when there are minimum one document what should be signed
        if (dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0) {
            dsPackage.dsDocuments.forEach((oneDoc) => {
                if ((oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned) ||
                    oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE ||
                    oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD) {

                    should = true
                }
            })
        }




        // CHECK if the invitation was sent




        // no status history, normally never happen this
        if (!dsPackage || !dsPackage.statusHistory) {
            return should
        }

        // check if not closed the package
        dsPackage.statusHistory.forEach((oneStatus) => {
            // the best case, when signed, no more remainder necessary
            if (oneStatus.status === c.DS_PACKAGE_STATUS_FINISHED) {
                should = false
            }

            // any cases when the package life is over, no more remainder necessary
            if (oneStatus.status === c.DS_PACKAGE_STATUS_REJECTED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_REVOKED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_EXPIRED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_FAILED ||
                oneStatus.status === c.DS_PACKAGE_STATUS_DELETED
            ) {
                should = false
            }
        })

        return should
    }

    /**
    * This is the call-back function of the email changer popup.
    * It will get the updated dsPackage after editing stakeholders data
    */
    onAfterUpdateClientEmail = async () => {
        const { dsPackage } = this.state

        //update stakeholders if the case
        if (dsPackage) {
            await this.fetchDsPackageToDisplay(dsPackage._id)
            this.setState({ editClientEmail: false, editClientPhoneNumber: false, stakeholderToEdit: null })
        }
        // release the email changer modal
        this.setState({ editClientEmail: false, stakeholderToEdit: null, editClientPhoneNumber: false })
    }

    /**
    * This function render the status history data-table
    */
    renderStatusHistory = (statusHistory) => {
        return (<div className={styles.statusHistoryContainer}>
            <Table
                ref={el => { this.tableStatusHist = el }}
                id="table"
                className={styles.statusHistoryTable}
                itemsPerPage={50}
                pageButtonLimit={5}
            >
                <Thead>
                    <Th column="setOn">
                        <strong>{_("setOn")}</strong>
                    </Th>
                    <Th column="status">
                        <strong>{_("status")}</strong>
                    </Th>
                </Thead>

                {statusHistory.map((item, key) =>
                    <Tr i={key} key={key}>
                        <Td column="setOn">
                            {(item.setOn && moment(item.setOn).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                        </Td>
                        <Td column="status">
                            <a
                                className={cs(styles.status, styles.goToLink)}
                                onClick={(ev) => {
                                    ev.stopPropagation()
                                    if (item.status) {
                                        this.onItemStatusClick(item.status)
                                    }
                                }}>
                                {item.status ? _(getStatusTranslationKey(item.status)) : '-'}
                            </a>
                        </Td>
                    </Tr>
                )}
            </Table>
            <br />
        </div>)
    }

    /**
     * This will generate the PDF and forward to the ling toward it to print.
     * @param {Object} oneDocument
     */
    async printPDFManually(oneDocument, packageId) {
        const { dispatch } = this.props

        let linkForPdfDownload = HALF_FILLED_PDF_API_URL + "/" + oneDocument._id
        let w = window.open(linkForPdfDownload, '_blank', 'noopener,noreferrer')
        let onLoadWindowPromise = new Promise((resolve) => {
            w.addEventListener('load', () => {
                resolve()
            }, true)
        })

        await onLoadWindowPromise
        await dispatch(handlePackageAfterPrint(packageId))
        await this.fetchDsPackageToDisplay(packageId)
    }

    /**
    * This function render the status history data-table
    */
    renderDocumentsList = (dsDocuments, statusToShow) => {
        const { lang, DSDocumentOriginTypes } = this.props
        const { dsPackage } = this.state
        const totalNumberOfSigners = dsPackage.stakeholders.length

        return (<div className={styles.documentsListContainer}>
            <Table
                ref={el => { this.tableStatusHist = el }}
                id="table"
                className={styles.documentsListTable}
                itemsPerPage={50}
                pageButtonLimit={5}
            >
                <Thead>
                    <Th column="documentName">
                        <strong>{_("documentName")}</strong>
                    </Th>
                    <Th column="documentLanguage">
                        <strong>{_("documentLanguage")}</strong>
                    </Th>
                    <Th column="status">
                        <strong>{_("status")}</strong>
                    </Th>
                    <Th column="documentLocation">
                        <strong>{_("documentLocation")}</strong>
                    </Th>
                    <Th column="printSection">
                        <div></div>
                    </Th>
                </Thead>

                {dsDocuments.map((oneDoc, key) =>
                    <Tr i={key} key={key}>
                        <Td column="documentName">
                            {oneDoc.fileName || "-"}
                        </Td>
                        <Td column="documentLanguage">
                            {_(oneDoc.language)}
                        </Td>
                        <Td column="status">
                            {statusToShow ? _(getStatusTranslationKey(statusToShow)) : ''}
                        </Td>
                        <Td column="documentLocation">
                            <a className={styles.goToLinkTable}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.navigateTo(oneDoc, false)
                                }}
                            >
                                {oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && oneDoc.claimNumber}
                                {oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && oneDoc.contractNumber}
                                {oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && oneDoc.contractNumber}
                                {oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && dsPackage.clientNumber}
                                {oneDoc.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && oneDoc.tarificationNumber}
                            </a>
                        </Td>
                        <Td column='printSection' >
                            {(!oneDoc.origin || oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED) ?
                                <div
                                    type="button"
                                    className={cs(
                                        documentStyles.short1
                                    )}
                                    onClick={(e) => {
                                       
                                        return this.printPDFManually(oneDoc, dsPackage._id)
                                    }}
                                >
                                    <img
                                        className={cs(documentStyles.checkIcon)}
                                        src={this.getIcon('print-black-18dp.svg')}
                                    />
                                    {oneDoc.isPrinted &&
                                        <img
                                            className={cs(documentStyles.checkIcon)}
                                            src={this.getIcon('ic_done_green_32px.svg')}
                                        />}
                                </div>
                                :
                                <div className={documentStyles.emptyPrintSpace}></div>
                            }
                        </Td>
                    </Tr>
                )}
            </Table>
            <br />
        </div >)
    }

    /**
     * This function will navigate to the target module by entity id (contracts, claims)
     * @param {object} dsdocument - dsdocument record
     */
    navigateTo(dsdocument) {
        // navigateToModuleName, dynamicId, clientId, options)
        const { dispatch } = this.props
        const { dsPackage } = this.state

        const clientId = nesProp.get(dsPackage, "clientId")
        const contractId = nesProp.get(dsdocument, "contractId")
        const claimId = nesProp.get(dsdocument, "claimId")
        const tarificationId = nesProp.get(dsdocument, "tarificationId")
        let dynamicId = clientId
        let navigateToModuleName = ''

        // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
            dynamicId = claimId
            navigateToModuleName = 'claims'
        }

        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM) {
            dynamicId = contractId
            navigateToModuleName = 'contracts'
        }

        if (dsdocument.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
            dynamicId = tarificationId
            navigateToModuleName = 'tarification'
        }

        // this next line of code (commented) can get clientId from oracle by contract or claim
        // getClientId(contractId, claimId).then((clientId)=>{  })

        dispatch(setAppModule(c.CLIENTS, clientId))
        dispatch(setOpenedSubmenu(dynamicId, {}))// submenuOpened: claimId, subModuleZoom: {}
        dispatch(setClientSubModule(navigateToModuleName))// subModule: 'claims' subModuleZoom: ''
    }

    /**
     * Used to determine the status for each document
     * @param {*} oneDoc
     * @returns upload, signed status or package status
     */
    determineStatusForDocument(oneDoc) {
        const { dsPackage } = this.state

        let statusToDisplay = '---'
        if (oneDoc.uploadedToOracle) {
            statusToDisplay = _('uploadedToOracle')
        }

        if (!oneDoc.uploadedToOracle && ((oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned) || oneDoc.origin === "DS_ORIGIN_ORACLE") && !dsPackage.isEditable
            && dsPackage.dsStakeholders.find(oneStakeholder => !oneStakeholder.finished)) {
            statusToDisplay = _('notSigned')
        }

        if (!oneDoc.uploadedToOracle && ((oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned) || oneDoc.origin === "DS_ORIGIN_ORACLE") && !dsPackage.isEditable
            && dsPackage.dsStakeholders.find(oneStakeholder => !oneStakeholder.finished)) {
            statusToDisplay = _('signed')
        }
        if (dsPackage.isEditable) {
            statusToDisplay = dsPackage.status ? _(getStatusTranslationKey(dsPackage.status)) : '-'
        }
        return statusToDisplay
    }

    simpleRefresh() {
        const { openedPackage, } = this.props
        this.fetchDsPackageToDisplay(openedPackage)
    }

    async collectTicketData(ticketId) {
        const { dispatch, DSDocumentOriginTypes } = this.props
        let ticket
        let ticketDocuments = []
        let selectedTicketDocuments = []
        let emailAttachmentTicketDocuments = []

        if (ticketId) {
            ticket = await dispatch(fetchOneTicketById(ticketId))
            if (ticket) {

                for (const oneDocId of ticket.documents) {
                    ticketDocuments.push({ oracleDocumentId: oneDocId, oracleDocumentType: nesProp.get(ticket, 'typeDocument'), origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE })
                }

                for (const oneSelectedDoc of ticket.signatureDocuments) {
                    selectedTicketDocuments.push({
                        oracleDocumentId: oneSelectedDoc,
                        oracleDocumentType: nesProp.get(ticket, 'typeDocument'),
                        origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE
                    })
                }

                for (const oneSelectedDoc of ticket.emailAttachmentTicketDocuments) {
                    emailAttachmentTicketDocuments.push({
                        oracleDocumentId: oneSelectedDoc,
                        oracleDocumentType: nesProp.get(ticket, 'typeDocument'),
                        origin: DSDocumentOriginTypes.DS_ORIGIN_ORACLE
                    })
                }
            }
        }

        return { ticketId, ticketDocuments, selectedTicketDocuments, emailAttachmentTicketDocuments }
    }

    async collectModuleOptionsValues(dsPackage) {
        const { dispatch, lang } = this.props
        let { clientId, contractId, tarificationId, claimId } = dsPackage

        //get client related data
        let clientData = null
        let emails = []
        if (clientId) {
            const fetchClientResponse = await dispatch(fetchClient(clientId))
            if (fetchClientResponse && fetchClientResponse.client) {
                clientData = fetchClientResponse.client
            }

            emails = nesProp.get(clientData, 'detail.emails')
            if (emails && emails.length) {
                emails = emails.map((item) => ({
                    referenceId: clientId,
                    label: nesProp.get(clientData, "main.name"),
                    value: item.email,
                    default: (item.default == "true" || item.default == true) ? true : false
                }))

                emails = emails.sort((item, item2) => {
                    if (item.default && !item2.default) { return -1 }
                    if (!item.default && item2.default) { return 1 }
                    if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
                }) || []
            }
        }



        //get tarification data
        let tarificationData = null
        if (tarificationId) {
            const fetchTarificationResponse = await dispatch(fetchClientTarification(tarificationId))
            if (fetchTarificationResponse && fetchTarificationResponse.response) {
                tarificationData = fetchClientTarification.response
            }
        }

        //get claim and related package data
        let claimData
        if (claimId && clientId) {
            const fetchClaimResponse = await dispatch(fetchClientOneClaim(clientId, claimId, dsPackage.userId))
            if (fetchClaimResponse) {
                claimData = fetchClaimResponse
                if (claimData && claimData.claimMain && claimData.claimMain.contractNumber && clientData) {
                    for (const oneContract of clientData.contracts) {
                        if (oneContract.contractMain.contractNumber === claimData.claimMain.contractNumber) {
                            contractId = oneContract.contractMain.contractId
                        }
                    }
                }
            }
        }

        //get contract data
        let contractData = null
        if (contractId) {
            const fetchContractResponse = await dispatch(fetchClientContract(contractId))
            if (fetchContractResponse && fetchContractResponse.response) {
                contractData = fetchContractResponse.response
            }
        }

        return {
            clientDocuments: nesProp.get(clientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,
            clientId,
            clientName: nesProp.get(clientData, "main.name"),
            clientNumber: nesProp.get(clientData, "main.clientNumber"),
            clientLanguage: lang,
            clientEmails: emails,

            // new v6 mode
            claimNumber: nesProp.get(claimData, "claimMain.claimNumber"),
            claimDocuments: nesProp.get(claimData, "claimDocuments"),
            claimDocumentsType: "claim",
            claimDocumentsId: claimId,
            // claimId: false,

            contractNumber: nesProp.get(contractData, 'contractMain.contractNumber'),
            contractDocuments: nesProp.get(contractData, 'contractDocuments'),
            contractDocumentsType: "contract",
            contractDocumentsId: contractId,
            contractId: contractId,

            tarificationNumber: nesProp.get(tarificationData, 'tarificationNumber'),
            tarificationDocuments: nesProp.get(tarificationData, "tarificationDocuments"),
            tarificationDocumentsType: "tarification",
            tarificationDocumentsId: tarificationId,

            company: nesProp.get(contractData, 'contractMain.insuranceCompany'),
            companyCancelMail: nesProp.get(contractData, 'contractMain.companyCancelMail'),
            brokerNumber: nesProp.get(dsPackage, "brokerNumber"),

            clientData: nesProp.get(clientData, "main"),
        }
    }

    /**
     * Handle the reset process, when the user click on the reset button
     * @param {object} dsPackage
     * @returns nothing
     */
    onClickRecreatePackage = async (dsPackage) => {
        const { dispatch, zoomOut } = this.props

        // this function will be called when the operation is failed
        // it will show a popup with the error message
        let onErrorPopup = async (error) => {
            return this.setState({
                isOpenAreYouSure: {
                    title: _('areYouSureModalTitle'),
                    message: _('recreatePackageError') + " " + _(error.name) + " code:" + _(error.callIDForDebug),
                    noCancelButton: true,
                    callBackCancel: () => {
                        this.setState({ isOpenAreYouSure: false })
                    },
                    callBackOk: async () => {
                        this.setState({ isOpenAreYouSure: false })
                    }
                }
            })
        }

        // this function will be called when the operation is success
        // it will show a popup with the success message
        let onSuccesPopup = async (dsPackage) => {
            return this.setState({
                isOpenAreYouSure: {
                    title: _('areYouSureModalTitle'),
                    message: _('recreatePackageSuccess'),
                    noCancelButton: false,
                    callBackCancel: () => {
                        this.setState({ isOpenAreYouSure: false, dsPackage })
                    },
                    callBackOk: async () => {
                        this.setState({ isOpenAreYouSure: false, dsPackage, autoOpenMifid: true })
                        //await dispatch(zoomOut())
                    }
                }
            })
        }

        // this function will be called when the user click on the confirm button
        // it will call the backend to recreate the package
        let onConfirmResetCallback = async () => {
            let resultrecreateDsPackage
            try {
                resultrecreateDsPackage = await dispatch(recreateDsPackage(dsPackage.id))
            } catch (error) {
                console.error(error)
                return onErrorPopup(error)
            }

            dsPackage = await dispatch(getOneDsPackageById(dsPackage.id))

            return onSuccesPopup(dsPackage)
        }

        // this is an init data for the popup on the first time to ask the user if he is sure to recreate the package
        let initAreYouSureData = {
            title: _('areYouSureModalTitle'),
            message: _('areYouSureToRecreteThePackage'),
            callBackCancel: () => {
                this.setState({ isOpenAreYouSure: false })
            },
            callBackOk: onConfirmResetCallback
        }

        // show the popup to ask the user if he is sure to recreate the package
        return this.setState({ isOpenAreYouSure: initAreYouSureData })
    }

    async onSendInvitationClick(packageId) {
        const { dispatch } = this.props
        const dsPackage = await dispatch(getActualizedPackageForInvitation(packageId))
        if (!dsPackage.error && canSendInvitation(dsPackage)) {
            return true
        } else {
            this.setState({ reminderConfirmationModal: true, invitationBlocked: true })
            this.fetchDsPackageToDisplay(packageId)
            return false
        }
    }

    render() {
        const { statusExplainerIsOpen, canCreateMifid, editClientEmail, editClientPhoneNumber,
            stakeholderToEdit, isOpenLinkDocumentModal, isLoaded, moduleOptions, ticketData,
            reminderConfirmationModal, reminderSentSuccessFlag, invitationBlocked, } = this.state
        const { createmail, dispatch, forceOpenInvitationEditor, forceOpenInvitationFromTicket, zoomOut } = this.props
        let { dsPackage, isOpenAreYouSure } = this.state
        const contractNumber = nesProp.get(dsPackage, 'contractNumber')
        let statusHistory = nesProp.get(dsPackage, "statusHistory")

        // calculate and collect flags for logical operations
        let shouldSendRemainder = this.shouldSendRemainder(dsPackage)
        let isEditableThePackage = shouldEditThePackage(
            nesProp.get(dsPackage, "statusHistory"),
            nesProp.get(dsPackage, "isEditable")
        )
        // don't show the last status, must shown the signed status in case when the document is signed: BEWB-445
        const isUploaded = this.documentsAreUploaded(nesProp.get(dsPackage, "status"), nesProp.get(dsPackage, "statusHistory"))
        let statusToShow = nesProp.get(dsPackage, "status") || ""
        if (dsPackage.mustBeSigned) {
            if (dsPackage.hasFinishStatus) {
                statusToShow = c.DS_PACKAGE_STATUS_FINISHED
            }
        } else {
            if (isUploaded) {
                statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE
            }
        }

        if (!isLoaded) {
            return <div></div>
        }

        // for overview emailer
        let emailModuleOptionsInviteOnlyNotInvited = dsPackage.dsStakeholders && dsPackage.dsStakeholders.length > 0 && {
            ...moduleOptions,
            dsPackage: dsPackage,
            brokerNumber: nesProp.get(dsPackage, "brokerNumber"),
            brokerEmailAddress: nesProp.get(dsPackage, "brokerEmailAddress"),
            autoSelectTemplate: true,
            usePlaceholdersForClientVariables: true,
            stakeholders: dsPackage.dsStakeholders.filter((oneStake) => ((oneStake.signerType !== "BROKER") && (!oneStake.isInvited))),
            clientEmails: dsPackage.dsStakeholders
                .filter((oneStake) => ((oneStake.signerType !== "BROKER") && (!oneStake.isInvited)))
                .map((oneHolder) => ({
                    referenceId: oneHolder._id,
                    value: oneHolder.email,
                    lang: oneHolder.language,
                    isPermanentSelected: true,
                    isCC: false,
                    label: oneHolder.firstName + " " + oneHolder.lastName
                })
                )
        }

        // for emailaddress correction modal, resend for all
        let emailModuleOptionsInviteAll = {
            ...moduleOptions,
            dsPackage: dsPackage,
            brokerNumber: nesProp.get(dsPackage, "brokerNumber"),
            brokerEmailAddress: nesProp.get(dsPackage, "brokerEmailAddress"),
            autoSelectTemplate: true,
            usePlaceholdersForClientVariables: true,
            stakeholders: dsPackage.dsStakeholders.filter((oneStake) => (oneStake.signerType !== "BROKER")),
            clientEmails: dsPackage.dsStakeholders
                .filter((oneStake) => (oneStake.signerType !== "BROKER"))
                .map((oneHolder) => ({
                    referenceId: oneHolder._id,
                    value: oneHolder.email,
                    lang: oneHolder.language,
                    isPermanentSelected: true,
                    isCC: false,
                    label: oneHolder.firstName + " " + oneHolder.lastName
                })
                )
        }

        let selectedTicketRelatedOraDocuments = ticketData.emailAttachmentTicketDocuments || []

        return (
            <div className={styles.dsdocumentContainer}>
                <h2 className={styles.mainTitle}>
                    {_('packageName') + (dsPackage && ' - "' + nesProp.get(dsPackage, "connectivePackageName") + '"' || '')}
                </h2>
                {dsPackage &&
                    <div className={styles.dsdocumentHeaderContainer}>
                        <div className={styles.columnWrapper}>
                            <div className={cs(styles.columnLeft)}>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('clientName')}:</p>
                                    <p className={styles.column}>{nesProp.get(dsPackage, "clientName")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('clientEmail')}:</p>
                                    <p className={styles.column}>{nesProp.get(dsPackage, "clientEmailAddress")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('brokerNumber')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsPackage, "brokerNumber")}</p>
                                </div>
                                {contractNumber &&
                                    <div className={cs(styles.row)}>
                                        <p className={styles.column}>{_('contractNumber')}: </p>
                                        <p className={styles.column}>{contractNumber}</p>
                                    </div>
                                }
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('createdByFullName')}: </p>
                                    <p className={styles.column}>{dsPackage.userFullName}</p>
                                </div>
                            </div>
                            <div className={cs(styles.columnRight)}>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('createdAt')}: </p>
                                    <p className={styles.column}>
                                        {(dsPackage && dsPackage.createdAt && moment(dsPackage.createdAt).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('updatedAt')}: </p>
                                    <p className={styles.column}>
                                        {((dsPackage.updatedAt != undefined) && moment(dsPackage.updatedAt).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('signedAt')}: </p>
                                    <p className={styles.column}>
                                        {this.getSigningDate(dsPackage) || "-"}
                                    </p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('packageStatus')}: </p>
                                    <a className={cs(styles.column, styles.goToLink)}
                                        onClick={(ev) => {
                                            ev.stopPropagation()
                                            if (statusToShow) {
                                                this.onItemStatusClick(statusToShow)
                                            }
                                        }}
                                    >
                                        {statusToShow ? _(getStatusTranslationKey(statusToShow)) : ''}
                                    </a>
                                </div>
                                <div className={cs(styles.row)}>
                                    <p className={styles.column}>{_('packageExpiration')}: </p>
                                    <p className={styles.column}>{nesProp.get(dsPackage, "expirationOn")}</p>
                                </div>
                                <div className={cs(styles.row)}>
                                    <div className={cs(styles.row, styles.mifidContainer)}>

                                        {canCreateMifid &&
                                            <MifidButton
                                                step={c.DSWIZARD_STEP_1_COMPOSE_PACKAGE}
                                                packageId={nesProp.get(dsPackage, "_id")}
                                                lang={lang}
                                                callBackOnClose={() => {
                                                    this.onCloseDSWizard()
                                                }}
                                                moduleKeyToSet={nesProp.get(dsPackage, "uploadedOnModule")}

                                                clientId={nesProp.get(dsPackage, "clientId")}
                                                claimId={nesProp.get(dsPackage, "claimId")}
                                                claimNumber={nesProp.get(dsPackage, "claimNumber")}
                                                contractId={nesProp.get(dsPackage, "contractId")}
                                                contractNumber={nesProp.get(dsPackage, "contractNumber")}
                                                tarificationId={nesProp.get(dsPackage, "tarificationId")}
                                                tarificationNumber={nesProp.get(dsPackage, "tarificationNumber")}
                                                stakeholders={nesProp.get(dsPackage, "dsStakeholders")}
                                                claimWizardDocType={nesProp.get(dsPackage, "claimWizardDocType")}
                                                alienUserId={dsPackage.userId}
                                                hideButton={!isEditableThePackage}
                                                isResume={true}
                                                moduleOptions={moduleOptions}
                                                ticketId={ticketData.ticketId}
                                                ticketDocuments={ticketData.ticketDocuments}
                                                selectedTicketDocuments={ticketData.selectedTicketDocuments}
                                                emailAttachmentTicketDocuments={ticketData.emailAttachmentTicketDocuments || []}
                                                openTrigger={this.state.autoOpenMifid}
                                            />
                                        }

                                        <DsListButtonsWrapper
                                            dsPackage={dsPackage || {}}
                                            isList={false}
                                            method={(dsDocument) => {
                                                return this.openLinkAndUploadWizard(dsDocument)
                                            }}
                                            directSignMethod={(id) => this.onDirectSignButtonClick(id)}
                                            showInvitation={false}
                                        />
                                        {(forceOpenInvitationEditor || forceOpenInvitationFromTicket) && createmail &&
                                            <EmailButton
                                                customButtonLabel={_('customizeInvitationEmail')}
                                                isWhiteIcon={true}
                                                modalId={c.EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS}
                                                hideCC={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? false : true}
                                                multiLanguage={true}
                                                serialSending={true}
                                                isCreatable={dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE ? true : false}
                                                forceIsMulti={true}
                                                key={"customizeInvitationRenderEmailSenderButtonFromEmailChangerKeyTemp"}
                                                onInit={() => {
                                                    this.onInitEmailer(selectedTicketRelatedOraDocuments)
                                                }}
                                                onSentLate={async (responses) => {
                                                    dsPackage = await this.onSentEmailer(responses, dsPackage, dsPackage.dsStakeholders)
                                                    //if originate from tickets navigate back
                                                    if (forceOpenInvitationFromTicket) {
                                                        dispatch(setOpenInvitationEditorFromTicket(false))
                                                        dispatch(setAppModule(c.INBOX, null))
                                                        return

                                                    }
                                                    //navigate back to ds list
                                                    await zoomOut()
                                                    await dispatch(setOpenInvitationEditor(false))
                                                }}
                                                moduleKeyToSet={getEmailerModuleKeyByWizardModuleKey(nesProp.get(dsPackage, "uploadedOnModule"))}
                                                moduleOptions={emailModuleOptionsInviteOnlyNotInvited}
                                                getDSStakeholders={async (stakeholderIdArray) => {
                                                    let listOfHolders = await dispatch(getDSStakeholders(stakeholderIdArray))
                                                    listOfHolders = listOfHolders.filter((oneStake) => ((oneStake.signerType !== "BROKER") && (!oneStake.isInvited)))
                                                    return listOfHolders
                                                }
                                                }
                                                customClassName={documentStyles.greenButton + " enabled"}
                                                onCancel={async () => {
                                                    //if originate from tickets navigate back
                                                    if (forceOpenInvitationFromTicket) {
                                                        dispatch(setOpenInvitationEditorFromTicket(false))
                                                        dispatch(setAppModule(c.INBOX, null))
                                                        return
                                                    }
                                                    //navigate back to ds list
                                                    await zoomOut()
                                                    await dispatch(setOpenInvitationEditor(false))
                                                }}
                                            />}
                                        {dsPackage && !isEditableThePackage && !dsPackage.hasFinishStatus && dsPackage.mustBeSigned &&
                                            <div className={cs(styles.bottomButtonsContainer)}>
                                                <div className={cs(documentStyles.marginBot)}>
                                                    <button className={cs(
                                                        documentStyles.greenButton,
                                                        documentStyles.greenButtonDsList,
                                                        "enabled",
                                                        styles.buttonCustomizationRenew
                                                    )}
                                                        onClick={async (ev) => {
                                                            ev.stopPropagation()

                                                            await this.onClickRecreatePackage(dsPackage)

                                                        }}
                                                    >
                                                        <img className={cs(styles.icon, styles.iconHeight)} src={this.getIcon('autorenew_white.svg')} />
                                                        {_('extendExpirationText')}
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }

                {dsPackage && dsPackage.mustBeSigned ?
                    (dsPackage.dsStakeholders && dsPackage.dsStakeholders.length > 0 ?
                        this.renderStakeholdersArea(isEditableThePackage, shouldSendRemainder) :
                        (dsPackage.clientEmailAddress ?
                            this.renderSignerArea(isEditableThePackage, shouldSendRemainder) :
                            null
                        ))
                    :
                    (dsPackage && !dsPackage.mustBeSigned ?
                        (<div>
                            <h2 className={`${styles.mainTitle}`}>
                                {_('signersArea')}
                            </h2>
                            <div className={styles.dsdocumentHeaderContainer}>
                                <div className={styles.signersLabelsColumn}>
                                    <div className={cs(styles.row)}>
                                        <p className={cs(styles.signersLabel)}>{_('documentNotRequireSignig')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>)
                        : null)
                }

                {(dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.length > 0) &&
                    <div>
                        <h2 className={`${styles.mainTitle}`}>
                            {_('dsDocuments')}
                        </h2>
                        <div className={styles.dsdocumentHeaderContainer}>
                            <div className={cs(styles.row)}>
                                <div className={styles.column}>
                                    {this.renderDocumentsList(dsPackage.dsDocuments, statusToShow)}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <h2 className={`${styles.mainTitle}`}>
                    {_('packageStatusHistory')}
                </h2>
                <div className={styles.dsdocumentHeaderContainer}>
                    <div className={cs(styles.row)}>
                        <div className={styles.column}>
                            {statusHistory && statusHistory.length > 0 &&
                                this.renderStatusHistory(statusHistory)
                            }
                        </div>
                    </div>
                </div>


                <AreYouSureModal
                    isOpen={Boolean(isOpenAreYouSure)}
                    style={customModalStyles}
                    contentLabel={""}
                    isOpenAreYouSure={isOpenAreYouSure ? isOpenAreYouSure : {}}
                    didClose={() => {
                        this.setState({ isOpenAreYouSure: false })
                    }}
                    key={"AreYouSureModal"}
                ></AreYouSureModal>

                <Modal
                    contentLabel={""}
                    isOpen={Boolean(statusExplainerIsOpen)}
                    style={customModalStyles}
                >
                    {statusExplainerPopup(
                        _(getStatusTranslationKey(statusExplainerIsOpen)),
                        _(getStatusDescriptionTranslationKey(statusExplainerIsOpen)),
                        () => {
                            this.setState({ statusExplainerIsOpen: false })
                        },
                        _("ok")
                    )}
                </Modal>

                <ReminderEmailStatusDialog
                    isOpen={reminderConfirmationModal}
                    success={reminderSentSuccessFlag}
                    invitationBlocked={invitationBlocked}
                    closeModal={() => this.setState({ reminderConfirmationModal: false, invitationBlocked: false, reminderSentSuccessFlag: false })}
                />

                <ClientContactInfoChangerModalForPackage
                    dsPackage={dsPackage}
                    triggerToOpen={editClientEmail || editClientPhoneNumber}
                    editClientEmail={editClientEmail}
                    editClientPhoneNumber={editClientPhoneNumber}
                    stakeholder={stakeholderToEdit}
                    isEditableThePackage={isEditableThePackage}
                    callBackOnClose={() => { this.onAfterUpdateClientEmail() }}
                    moduleKeyToSet={getEmailerModuleKeyByWizardModuleKey(nesProp.get(dsPackage, "uploadedOnModule"))}
                    emailerModuleOptions={emailModuleOptionsInviteAll}
                    onSentEmailer={async (responses, dsPackageNew, stakeholdersNew) => {
                        dsPackage = await this.onSentEmailer(responses, dsPackageNew, stakeholdersNew)

                        this.setState({ dsPackage })
                        return dsPackage

                    }}
                    onInitEmailer={() => {
                        this.onInitEmailer(selectedTicketRelatedOraDocuments)
                    }}
                />

                <LinkDocumentsModal
                    modalIsOpen={!!isOpenLinkDocumentModal}
                    onCancel={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.simpleRefresh()
                    }}
                    onConfirmation={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.simpleRefresh()
                    }}
                    flag={'LinkDocumentModal'}
                    payload={isOpenLinkDocumentModal ?
                        {
                            dsPackage: isOpenLinkDocumentModal
                        } : {}
                    }
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/detailedPackage.jsx